/* ATF Upgrade — Interaktion zu den Liquid-Blocks.
   Markup kommt aus Liquid, hier steht nur Verhalten: Sprung zu den
   Bewertungen und der Slider im Zitat-Kasten. */
(function () {
  'use strict';

  if (window.mlAtfUpgrade) return;
  window.mlAtfUpgrade = true;

  /* Sanft scrollen, aber nie haengen bleiben: gedrosselte Tabs fuehren
     smooth-Animationen nicht aus, dann wird der Wert hart gesetzt. */
  function sanft(lesen, setzen, ziel) {
    var vorher = lesen();
    if (Math.abs(ziel - vorher) < 2) return;
    try {
      setzen(ziel, true);
    } catch (e) {
      setzen(ziel, false);
      return;
    }
    setTimeout(function () {
      if (Math.abs(lesen() - vorher) < 2) setzen(ziel, false);
    }, 400);
  }

  function stickyOffset() {
    var head = document.querySelector('.section-header, [id$="__header"], header');
    if (!head) return 20;
    var pos = window.getComputedStyle(head).position;
    var h = head.getBoundingClientRect().height;
    return (pos === 'fixed' || pos === 'sticky') && h > 0 ? h + 16 : 20;
  }

  /* Sterne-Zeile: springt zu den Bewertungen. Das Judge.me-Widget rendert
     nach, das Ziel wird deshalb erst beim Klick gesucht. */
  function initScrollTo(el) {
    el.addEventListener('click', function () {
      /* Der Reihe nach probieren: querySelector mit Komma-Liste nimmt das im
         Dokument zuerst stehende Element, nicht den ersten Selektor. */
      var kandidaten = (el.getAttribute('data-ml-scroll-to') || '').split(',');
      var target = null;
      for (var i = 0; i < kandidaten.length && !target; i++) {
        var k = kandidaten[i].trim();
        if (!k) continue;
        try { target = document.querySelector(k); } catch (e) { target = null; }
      }
      if (!target) return;
      var y = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
      sanft(
        function () { return window.pageYOffset; },
        function (wert, weich) {
          if (weich) window.scrollTo({ top: wert, behavior: 'smooth' });
          else window.scrollTo(0, wert);
        },
        y
      );
    });
  }

  function initSlider(box) {
    var track = box.querySelector('.ml-rev__track');
    var dots = box.querySelectorAll('.ml-rev__dot');
    var slides = box.querySelectorAll('.ml-rev__slide');
    if (!track || slides.length < 2) return;

    var idx = 0;
    var paused = false;

    function setDots() {
      Array.prototype.forEach.call(dots, function (d, k) {
        d.setAttribute('aria-current', k === idx ? 'true' : 'false');
      });
    }

    function go(i) {
      idx = (i + slides.length) % slides.length;
      sanft(
        function () { return track.scrollLeft; },
        function (wert, weich) {
          if (weich) track.scrollTo({ left: wert, behavior: 'smooth' });
          else track.scrollLeft = wert;
        },
        track.clientWidth * idx
      );
      setDots();
    }

    Array.prototype.forEach.call(dots, function (d, i) {
      d.addEventListener('click', function () {
        paused = true;
        go(i);
      });
    });

    /* Dots mitziehen, wenn per Wisch gescrollt wird */
    var tick = null;
    track.addEventListener('scroll', function () {
      if (tick) clearTimeout(tick);
      tick = setTimeout(function () {
        var w = track.clientWidth || 1;
        var k = Math.round(track.scrollLeft / w);
        if (k !== idx) {
          idx = Math.max(0, Math.min(slides.length - 1, k));
          setDots();
        }
      }, 90);
    }, { passive: true });

    box.addEventListener('mouseenter', function () { paused = true; });
    box.addEventListener('touchstart', function () { paused = true; }, { passive: true });

    var delay = parseInt(box.getAttribute('data-autoplay'), 10);
    if (!isFinite(delay) || delay <= 0) return;
    var timer = setInterval(function () {
      if (!paused && document.visibilityState === 'visible') go(idx + 1);
    }, delay);
    window.addEventListener('pagehide', function () { clearInterval(timer); });
  }

  function boot(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-ml-scroll-to]'), function (el) {
      if (el.dataset.mlReady) return;
      el.dataset.mlReady = '1';
      initScrollTo(el);
    });
    Array.prototype.forEach.call(scope.querySelectorAll('[data-ml-review-slider]'), function (el) {
      if (el.dataset.mlReady) return;
      el.dataset.mlReady = '1';
      initSlider(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Theme-Editor rendert Blocks einzeln neu */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) { boot(e.target); });
})();
